import { MutationTree } from 'vuex';
import {
  TournamentState,
  TournamentMutations,
  UpdateRequestOrganizerComment,
  InitTournament, EditModes,
} from './types';
import {Vue} from 'vue-property-decorator';

export const mutations: MutationTree<TournamentState> = {
  [TournamentMutations.InitTournament](state: TournamentState, payload: InitTournament) {
    const requestEditModes: EditModes = {};
    if (payload && payload.requests) {
      payload.requests.forEach((x) => requestEditModes[x.id] = x.isApproved === null);
    }
    state = Object.assign(state, {
      tournamentId: payload.tournamentId,
      forumThreadId: payload.forumThreadId,
      requests: payload && payload.requests && payload.requests
        .slice()
        .map((x) => Object.assign(x, {id: x.id.toString()})),
      requestEditModes,
    });
  },
  [TournamentMutations.StartLoading](state: TournamentState) {
    state.isLoaded = false;
  },
  [TournamentMutations.FinishLoading](state: TournamentState) {
    state.isLoaded = true;
  },
  [TournamentMutations.ToggleRequestEditMode](state: TournamentState, payload: number) {
    if (state.requestEditModes) {
      const id = payload.toString();
      Vue.set(state.requestEditModes, id, !state.requestEditModes[id]);
    }
  },
  [TournamentMutations.UpdateRequestOrganizerComment](state: TournamentState, payload: UpdateRequestOrganizerComment) {
    if (payload) {
      const index = state.requests.findIndex((x) => x.id === payload.requestId);
      Vue.set(state.requests, index, Object.assign(state.requests[index], {
        organizerComment: payload.comment,
      }));
    }
  },
  [TournamentMutations.ApproveRequest](state: TournamentState, payload: string) {
    const index = state.requests.findIndex((x) => x.id === payload);
    Vue.set(state.requests, index, Object.assign(state.requests[index], {isApproved: true}));
  },
  [TournamentMutations.RejectRequest](state: TournamentState, payload: string) {
    const index = state.requests.findIndex((x) => x.id === payload);
    Vue.set(state.requests, index, Object.assign(state.requests[index], {isApproved: false}));
  },
  [TournamentMutations.HttpError](state: TournamentState) {
    state.hasHttpError = true;
  },
  [TournamentMutations.ClearHttpErrors](state: TournamentState) {
    state.hasHttpError = false;
  },
};
